<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <!-- Modernization Banner -->
    <BannerComponent
      imageSrc="capabilities/application modernization/application-modernization.jpg"
      :bannerHeadingColor="'#fff'"
      :isOverlay="true"
      heading="Application Modernization"
      subheading="Revitalize and Elevate the User Experience"
    />

    <div class="modernization-description" data-aos="fade-up">
      <v-row>
        <v-col
          :xs="12"
        >
          <p> {{ appModernizationDesc }} </p>
        </v-col>
      </v-row>
    </div>
    <CardComponent 
      :subHeading="`BENEFITS`"
      :cardItems="benefitsItems"
    />
    <CardComponent 
      :subHeading="`CORE CAPABILITIES`"
      :cardItems="coreCapabilitiesItems"
    />
    <SectionComponent
      relatedTitle="RELATED CAPABILITIES"
      paragraphContent="Our extraordinary team has successfully managed numerous mission and enterprise application modernization initiatives for government agencies, businesses and nonprofits. Our Agile approach and DevOps teams continue to successfully transform business applications ensuring the highest value-added return for our customers."
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    CardComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      appModernizationDesc: 'G14C Application Modernization services provides customers with the capabilities to modernize legacy applications, software and platforms. G14C provides analysis and engineering capabilities for converting, rewriting, and migrating outdated applications utilizing modern computer programming languages, architectures, software libraries, and protocols.',
      benefitsItems: [
        {
          id: 0,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'Improve human experience.jpg',
          text: 'Improve the Human Experience',
          hoverIcon: 'vector.png',
          hoverText: 'Understanding the human factor at every stage of the problem-solving process'
        },{
          id: 1,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'optimize app footprint.jpg',
          text: 'Optimize the Application Footprint',
          hoverIcon: 'chart.png',
          hoverText: 'Balancing the portfolio of applications based on business value, technical fit, and costs.'
        },{
          id: 2,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'reduce cost.jpg',
          text: 'Reduce the Total Cost of Ownership',
          hoverIcon: 'trend-down.png',
          hoverText: 'Weighing the mission importance, and the resiliency, reliability, agility, security, and service delivery to lower the total cost of ownership.'
        },{
          id: 3,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'security posture.jpg',
          text: 'Strengthen the Security Posture',
          hoverIcon: 'lock.png',
          hoverText: 'Strengthening security by identifying, retiring, and modernizing legacy applications that are exposed to data breaches and cyber-attacks.'
        }
      ],
      coreCapabilitiesItems: [
        {
          id: 4,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'Core capability 1.jpg',
          text: 'Application Analysis',
          hoverIcon: 'analysis.png',
          hoverText: 'Provides analysis of the application and technology footprint and prepares a framework for optimization of technology investments. Accelerates the adoption of UI modernization for a more immersive user experience.'
        },{
          id: 5,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'application rationalization.jpg',
          text: 'Application Rationalization',
          hoverIcon: 'inventory.png',
          hoverText: 'Identifies, inventories, assesses, and scores applications to determine importance and placement. Prioritizes application interoperability improvements using advanced API technology.'
        },{
          id: 6,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'application transformation.jpg',
          text: 'Application Transformation',
          hoverIcon: 'ai-brain.png',
          hoverText: 'Modernize legacy applications using Gen AI/ML, BPA, and RPA to transform the business into a responsive, and resilient enterprise.'
        },{
          id: 7,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'cloud application development.jpg',
          text: 'Cloud Application Development',
          hoverIcon: 'cloud-done.png',
          hoverText: 'Design, develop, and deploy applications using Cloud-native technologies for rapid delivery.'
        },{
          id: 8,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'low code no code.jpg',
          text: 'Low Code No Code Development',
          hoverIcon: 'software-license.png',
          hoverText: 'Utilizes the next generation software development platform to easily build, enhance, and maintain products and services.'
        },{
          id: 9,
          subFolder:'capabilities',
          folder:'application modernization',
          imageUrl: 'microservices.jpg',
          text: 'Microservices Architecture',
          hoverIcon: 'microservices.png',
          hoverText: 'Building Cloud native applications as microservices that enables a scalable framework while accelerating the time to develop, test and deploy apps.'
        }
      ],
      sectionContents: [
        '“This contractor has gone above and beyond to modernize critical applications necessary to improve the customer experience. The solution was designed, developed, and deployed quickly and with zero-disruption, and the customers that interact with the Food and Drug Administration (FDA) find it very useful.”',
        '“The team brings highly skilled engineers and are continuously bringing innovative solutions to modernize applications and improve performance allowing the Securities and Exchange Commission (SEC) to meet regulatory timeframes for filer compliance.”',
      ],
      additionalContent: [
        'FDA, COR', 
        'SEC, Assistant Director', 
      ],
      cardData: [
        {
          className: 'cloud',
          color: '#7594FE',
          heading: 'Cloud',
          link: 'cloud'
        },
        {
          className: 'devsecops',
          color: '#50E1FE',
          heading: 'DevSecOps',
          link: 'devsecops'
        },
        {
          className: 'security',
          color: '#E2BF66',
          heading: 'Security Data Lake',
          link: 'security-data-lake'
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>